import React, { useEffect, useState } from "react"
import Sidebar from "../../Components/Sidebar/Sidebar"
import DateTimeField from "../../Components/Commons/Forms/DateTimeField"
import NumberInput from "../../Components/Commons/Forms/NumberInput"
import BtnSave from "../../Components/Commons/Buttons/BtnSave"
// import Table from "../../Components/Commons/Table/Table"
import { Radio, Select } from "antd"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import { toast } from "react-toastify"

import "./Patients.css"
import { createVital } from "../Helpers/API/VitalSignsApi/VitalSignsApi"
import { getAllDoctors } from "../Helpers/API/DoctorApi/DoctorApi"

import BtnAdd from "../Commons/Buttons/BtnAdd"
import { createQueue } from "../Helpers/API/QueueApi/QueueApi"
import TextArea from "../Commons/Forms/TextArea"
import { getRole, getUser } from "../Helpers/Utilities/Common"
import DateField from "../Commons/Forms/DateField"
import { formatDateWithTimeHMS } from "../../Helpers/Utils/Common"
import TextField from "../Commons/Forms/TextField"
import CreateSelectField from "../Commons/Forms/CreateSelectField"
import { getAutoSuggestTherapeutics } from "../Helpers/API/CheckUpApi/CheckUpApi"


const { Option } = Select

function NewPatientVitalSigns() {
  const id = useParams()
  const role = getRole()
  const userId = getUser()
  const navigate = useNavigate()
  const state = useLocation()
  // const [row, setRow] = useState({
  //   id: 1,
  // })
  const [isLoading, setIsLoading] = useState(false)
  const [suggestComplaint, setSuggestComplaint] = useState([])
  const [selectedDoctor, setSelectedDoctor] = useState(null)
  const [doctors, setDoctors] = useState([])
  // const [ibwValue, setIbwValue] = useState(0)
  const [addVital, setAddVital] = useState({
    weight: "",
    weight_in_lb: "",
    height: "",
    height_in_ft: "",
    height_in_inch: "",
    bmi: "",
    ibw: "",
    waist: "",
    hip: "",
    whr: "",
    temperature: "",
    bp: "",
    heart_rate: "",
    respiratory_rate: "",
    oxygen_saturation: "",
    blood_type: "",
    left_eye_wo_correction: "",
    right_eye_wo_correction: "",
    left_eye_w_correction: "",
    right_eye_w_correction: "",

    length: "",
    head_circumference: "",
    skinfold_thickness: "",
    body_circumference_waist: "",
    hip_in_cm: "",
    limbs: "",
    muac: "",

    chief_complaint: "",
    has_complaint_2: "0",
    complaint_2: "",
    has_complaint_3: "0",
    complaint_3: "",
    has_complaint_4: "0",
    complaint_4: "",
    has_complaint_5: "0",
    complaint_5: "",
    has_complaint_6: "0",
    complaint_6: "",
    has_complaint_8: "0",
    complaint_8: "",
    first_mens_period: "",
    last_mens_period: "",
    preg_count: "",
    general_survey: "",
  })

  // const handleAddChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name === "height") {
  //     // Convert cm → inches → ft+in
  //     if (value.trim() === "") {
  //       setAddVital((prevState) => ({
  //         ...prevState,
  //         height_in_ft: "",
  //         height: "",
  //         height_in_inch: "",
  //       }));
  //       return;
  //     }

  //     const cm = parseFloat(value);
  //     if (!isNaN(cm)) {
  //       const totalInches = cm / 2.54;
  //       const feet = Math.floor(totalInches / 12);
  //       const inches = Math.round(totalInches % 12);

  //       const heightInFt = `${feet}'${inches}"`;

  //       setAddVital((prevState) => ({
  //         ...prevState,
  //         height: value, // keep cm
  //         height_in_inch: Math.round(totalInches), // inches
  //         height_in_ft: heightInFt,
  //       }));
  //     }
  //   } else if (name === "weight") {
  //     // Convert kg → lb
  //     if (value.trim() === "") {
  //       setAddVital((prevState) => ({
  //         ...prevState,
  //         weight: "",
  //         weight_in_lb: "",
  //       }));
  //       return;
  //     }

  //     const kg = parseFloat(value);
  //     if (!isNaN(kg)) {
  //       const lb = (kg * 2.20462).toFixed(2); // keep 2 decimals
  //       setAddVital((prevState) => ({
  //         ...prevState,
  //         weight: value, // kg
  //         weight_in_lb: lb,
  //       }));
  //     }
  //   } else {
  //     // Other inputs
  //     if (name === "complaint") {
  //       setAddVital((prevState) => ({
  //         ...prevState,
  //         [name]: value?.toUpperCase(),
  //       }));
  //     } else {
  //       setAddVital((prevState) => ({
  //         ...prevState,
  //         [name]: value,
  //       }));
  //     }
  //   }
  // };

  const handleAddComplaintChange = (e, search) => {
    if (search === "chief_complaint") {
      setAddVital((prevState) => ({
        ...prevState,
        complaint: e?.value,
      }))
    } else {
      const { name, value } = e.target
      setAddVital((prevState) => ({
        ...prevState,
        [name]: value,
      }))
    }
  }

  const handleAddChange = (e) => {
    const { name, value } = e.target

    if (name === "height") {
      // Convert cm → inches → ft+in
      if (value.trim() === "") {
        setAddVital((prevState) => ({
          ...prevState,
          height_in_ft: "",
          height: "",
          height_in_inch: "",
        }))
        return
      }

      const cm = parseFloat(value)
      if (!isNaN(cm)) {
        const totalInches = cm / 2.54
        const feet = Math.floor(totalInches / 12)
        const inches = Math.round(totalInches % 12)

        const heightInFt = `${feet}'${inches}"`

        setAddVital((prevState) => ({
          ...prevState,
          height: value, // keep cm
          height_in_inch: Math.round(totalInches), // inches
          height_in_ft: heightInFt,
        }))
      }
    } else if (name === "weight") {
      // Convert kg → lb
      if (value.trim() === "") {
        setAddVital((prevState) => ({
          ...prevState,
          weight: "",
          weight_in_lb: "",
        }))
        return
      }

      const kg = parseFloat(value)
      if (!isNaN(kg)) {
        const lb = (kg * 2.20462).toFixed(2) // keep 2 decimals
        setAddVital((prevState) => ({
          ...prevState,
          weight: value, // kg
          weight_in_lb: lb,
        }))
      }
    } else if (name === "hip") {
      // Convert hip inches → centimeters
      if (value.trim() === "") {
        setAddVital((prevState) => ({
          ...prevState,
          hip: "",
          hip_in_cm: "",
        }))
        return
      }

      const inches = parseFloat(value)
      if (!isNaN(inches)) {
        const cm = (inches * 2.54).toFixed(2) // convert to cm
        setAddVital((prevState) => ({
          ...prevState,
          hip: value, // keep inches
          hip_in_cm: cm,
        }))
      }
    } else if (name === "hip_in_cm") {
      // Convert hip centimeters → inches
      if (value.trim() === "") {
        setAddVital((prevState) => ({
          ...prevState,
          hip: "",
          hip_in_cm: "",
        }))
        return
      }

      const cm = parseFloat(value)
      if (!isNaN(cm)) {
        const inches = (cm / 2.54).toFixed(2) // convert to inches
        setAddVital((prevState) => ({
          ...prevState,
          hip: inches,
          hip_in_cm: value, // keep cm
        }))
      }
    } else if (name === "bp") {
      let digits = value.replace(/\D/g, "")
      if (digits.length > 6) {
        digits = digits.slice(0, 6)
      }

      let formatted = digits
      if (digits.length === 4) {
        formatted = `${digits.slice(0, 2)}/${digits.slice(2)}`
      } else if (digits.length > 4) {
        formatted = `${digits.slice(0, 3)}/${digits.slice(3)}`
      }

      setAddVital((prevState) => ({
        ...prevState,
        bp: formatted,
      }))
    } else {
      // Other inputs
      if (name === "complaint") {
        setAddVital((prevState) => ({
          ...prevState,
          [name]: value?.toUpperCase(),
        }))
      } else {
        setAddVital((prevState) => ({
          ...prevState,
          [name]: value,
        }))
      }
    }
  }

  async function handleSubmit() {
    setIsLoading(true)
    const response = await _createVitalSign(true)
    // Only stop loading if there was an error (so user can try again)
    // On success, loading continues until navigation completes
    if (response?.status !== 200) {
      setIsLoading(false)
    }
    // setTimeout(() => {
    //   navigate("/patients/fpe/" + id?.id, {
    //     state: {
    //       patient_sex: state?.state?.patient_sex,
    //       is_fpe: state?.state?.is_fpe,
    //       months: state?.state?.months,
    //       doctor_id: selectedDoctor,
    //       vitals: {
    //         weight: addVital?.weight,
    //         weight_in_lb: addVital?.weight_in_lb,
    //         height: addVital?.height,
    //         height_in_ft: addVital?.height_in_ft,
    //         height_in_inch: addVital?.height_in_inch,
    //         bmi: addVital?.bmi,
    //         ibw: addVital?.ibw,
    //         waist: addVital?.waist,
    //         hip: addVital?.hip,
    //         whr: addVital?.whr,
    //         temperature: addVital?.temperature,
    //         bp: addVital?.bp,
    //         heart_rate: addVital?.heart_rate,
    //         respiratory_rate: addVital?.respiratory_rate,
    //         oxygen_saturation: addVital?.oxygen_saturation,
    //         right_eye_vision: addVital?.right_eye_vision,
    //         left_eye_vision: addVital?.left_eye_vision,
    //         last_meal: formatDateWithTimeHMS(addVital?.last_meal) || "",
    //         length: addVital?.length,
    //         head_circumference: addVital?.head_circumference,
    //         skinfold_thickness: addVital?.skinfold_thickness,
    //         body_circumference_waist: addVital?.body_circumference_waist,
    //         hip_in_cm: addVital?.hip_in_cm,
    //         limbs: addVital?.limbs,
    //         muac: addVital?.muac, //middle_upper_arm_circumference
    //       },
    //       complaints: {
    //         chief_complaint: addVital?.complaint,
    //         complaint_2: addVital?.complaint_2,
    //         complaint_3: addVital?.complaint_3,
    //         complaint_4: addVital?.complaint_4,
    //         complaint_5: addVital?.complaint_5,
    //         complaint_6: addVital?.complaint_6,
    //         complaint_8: addVital?.complaint_8,
    //         first_mens_period: addVital?.first_mens_period,
    //         last_mens_period: addVital?.last_mens_period,
    //         preg_count: addVital?.preg_count,
    //         general_survey: addVital?.general_survey,
    //       },
    //     },
    //   });
    // }, 1000);
  }

  async function handleSchedule() {
    setIsLoading(true)
    const response = await _createVitalSign(true)
    // Only stop loading if there was an error (so user can try again)
    if (response?.status !== 200) {
      setIsLoading(false)
    }
  }

  async function _createVitalSign(navigateToProfile) {
    const response = await createVital(addVital, id.id)
    if (response.status !== 200) {
      console.log(response)
      toast.error(
        response?.response?.data?.messages?.error_messages[0] ??
          "An error occured"
      )
    } else {
      toast.success(response.data.message ?? "Success")
      
      // Check if coming from PhilHealth check - navigate directly to patient profile for Add to Queue flow
      if (state?.state?.fromPhilhealthCheck) {
        setTimeout(() => {
          navigate("/patients/profile/" + id.id, {
            state: {
              fromConsult: false,
              fromRegisterPatient: true,
              fromPhilhealthCheck: true,
            },
          })
          localStorage.setItem("isCheck", JSON.stringify(true))
          localStorage.setItem("isTrue", JSON.stringify(true))
          localStorage.setItem("vitalSignLab", JSON.stringify("vital_signs"))
          localStorage.setItem(
            "medicalHistory",
            JSON.stringify("medical_history")
          )
          localStorage.setItem(
            "chiefComplaint",
            JSON.stringify(addVital?.complaint)
          )
        }, 2000)
      } else if (navigateToProfile) {
        setTimeout(() => {
          navigate("/patients/profile/" + id.id, {
            state: {
              fromConsult: state?.state?.fromConsult || false,
              queue_id: state?.state?.queueId || "",
              queue_no: state?.state?.queueNo || "",
              fromRegisterPatient: state?.state?.fromRegisterPatient || false,
            },
          })
          localStorage.setItem("isCheck", JSON.stringify(true))
          localStorage.setItem("isTrue", JSON.stringify(true))
          localStorage.setItem("vitalSignLab", JSON.stringify("vital_signs"))
          localStorage.setItem(
            "medicalHistory",
            JSON.stringify("medical_history")
          )
          localStorage.setItem(
            "chiefComplaint",
            JSON.stringify(addVital?.complaint)
          )
          // localStorage.setItem("openAppointmentModal", JSON.stringify(true));
        }, 2000)
      }
    }
    return response
  }

  // async function _createQueue() {
  //   const response = await createQueue({
  //     patient_id: id.id,
  //     status: "queued",
  //     complaint: addVital.complaint,
  //     doctor_id: selectedDoctor,
  //   });

  //   if (response.data) {
  //     toast.success(response.data.message);
  //     navigate("/queue");
  //   } else if (response.error) {
  //     response.error.data.messages.error_messages.forEach((err) => {
  //       toast.error(err);
  //     });
  //   }
  // }

  async function fetchAllDoctors() {
    const response = await getAllDoctors()
    if (response.data) {
      // setDoctors(response.data.data);
      const mappedDoctors = response.data.data.map((doctor) => ({
        label: doctor.doctor_name,
        value: doctor.id,
        id: doctor.id,
        doctor_name: doctor.doctor_name,
      }))
      setDoctors(mappedDoctors)
    } else {
      setDoctors([])
    }
  }

  async function fetchAutoSuggestComplaint() {
    const response = await getAutoSuggestTherapeutics({
      table: "assessment",
      field: "complaint",
    })
    if (response.data) {
      setSuggestComplaint(
        response?.data?.data
          ?.filter((data) => data !== null && data !== undefined && data !== "")
          ?.map((data) => ({ label: data, value: data }))
      )
    } else {
      setSuggestComplaint([])
    }
  }

  useEffect(() => {
    // var patientSex = sex.toLowerCase();
    var inchOver5feet = 0
    var ibw = 0
    var vitalIbw = ""

    if (!addVital.height) {
      vitalIbw = ""
    } else {
      inchOver5feet = parseFloat(addVital.height) / 2.54 - 60

      if (state?.state?.patient_sex === "MALE") {
        // if (patientSex === "male") {
        ibw = 50 + 2.3 * inchOver5feet
      } else {
        ibw = 45.5 + 2.3 * inchOver5feet
      }
      vitalIbw = ibw.toFixed(2)
    }

    if (!addVital.weight || !addVital.height) {
      setAddVital({
        ...addVital,
        ibw: vitalIbw,
        bmi: "",
        // whr: "",
      })
    } else {
      setAddVital({
        ...addVital,
        // whr: parseFloat(addVital.waist / addVital.hip).toFixed(2),
        ibw: vitalIbw,
        bmi:
          parseFloat(
            addVital?.weight /
              ((addVital?.height / 100) * (addVital?.height / 100))
          ).toFixed(2) || "",
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addVital.height, addVital.weight])

  useEffect(() => {
    if (!addVital.waist || !addVital.hip) {
      setAddVital((prevState) => {
        return {
          ...prevState,
          whr: "",
        }
      })
    } else {
      setAddVital((prevState) => {
        return {
          ...prevState,
          whr: parseFloat(addVital.waist / addVital.hip).toFixed(2),
        }
      })
    }
  }, [addVital.waist, addVital.hip])

  useEffect(() => {
    fetchAllDoctors()
    fetchAutoSuggestComplaint()
  }, [])

  useEffect(() => {
    if (role === "director" || role === "pcp" || role === "specialist") {
      setSelectedDoctor(userId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role])

  return (
    <div className="App">
      <Sidebar />
      {/* <ToastContainer /> */}
      <div className="profile-container col p-5 pt-4">
        {/* <LabelHeader text={"Add Vital Sign"} /> */}
        <div className="ml-7 col font-big font-bold">Add Vital Signs</div>
        <div className="ml-7">
          <div className="row">
            <div className="col-sm-11">
              <div className="row mt-3">
                {/* {role === "nurse" && (
                  <>
                    <div className="col-6 mt-3">
                      <label>
                        ASSIGNED DOCTOR
                        <span className="red"> *</span>
                      </label>
                      <Select
                        style={{ width: "100%" }}
                        placeholder="Select Doctor"
                        onChange={setSelectedDoctor}
                        value={selectedDoctor}
                        allowClear
                        options={doctors}
                        optionFilterProp="label"
                        showSearch
                      />
                    </div>
                  </>
                )} */}
                {/* <div className="col-sm-4 mt-3">
                  <DateTimeField
                    // required={true}
                    id="last_meal"
                    name="last_meal"
                    formLabel={`LAST MEAL`}
                    size={`sm`}
                    onChange={handleAddChange}
                    // isError={}
                    errorMessage="This is an error"
                  />
                </div> */}
              </div>
              {state?.state?.months > 24 && (
                <>
                  <div className="row">
                    <div className="col-sm-3">
                      <NumberInput
                        id="weight"
                        name="weight"
                        formLabel={`WEIGHT (kg)`}
                        size={`sm`}
                        onChange={handleAddChange}
                        required={true}
                      />
                    </div>
                    <div className="col-sm-3">
                      <NumberInput
                        id="weight_in_lb"
                        name="weight_in_lb"
                        formLabel={`WEIGHT (lb)`}
                        value={addVital.weight_in_lb}
                        size={`sm`}
                        onChange={handleAddChange}
                        // isError={}
                        errorMessage="This is an error"
                        disabled={true}
                      />
                    </div>
                    <div className="col-sm-3">
                      <NumberInput
                        id="height"
                        name="height"
                        formLabel={`HEIGHT (cm)`}
                        value={addVital.height}
                        size={`sm`}
                        onChange={handleAddChange}
                        required={true}
                        // disabled={true}
                      />
                    </div>
                    <div className="col-sm-3">
                      <NumberInput
                        id="height_in_inch"
                        name="height_in_inch"
                        formLabel={`HEIGHT (in)`}
                        value={addVital.height_in_inch}
                        size={`sm`}
                        onChange={handleAddChange}
                        // isError={}
                        errorMessage="This is an error"
                        disabled={true}
                      />
                    </div>
                    {/* <div className="col-sm-3">
                  <NumberInput
                    id="height_in_ft"
                    name="height_in_ft"
                    formLabel={`HEIGHT (ft)`}
                    size={`sm`}
                    onChange={handleAddChange}
                    // isError={}
                    errorMessage="This is an error"
                  />
                </div> */}
                  </div>
                  <div className="row">
                    <div className="col-sm-3">
                      <NumberInput
                        id="bmi"
                        name="bmi"
                        formLabel={`BMI`}
                        value={addVital.bmi}
                        size={`sm`}
                        disabled={true}
                        required={true}
                        onChange={handleAddChange}
                      />
                    </div>
                    <div className="col-sm-3">
                      <NumberInput
                        id="ibw"
                        name="ibw"
                        formLabel={`IBW (kg)`}
                        size={`sm`}
                        value={addVital.ibw}
                        // value={addVital.height ? addVital.height : "0.00"}
                        onChange={handleAddChange}
                        disabled={true}
                      />
                    </div>
                    <div className="col-sm-3">
                      <NumberInput
                        id="waist"
                        name="waist"
                        formLabel={`WAIST (in)`}
                        size={`sm`}
                        onChange={handleAddChange}
                        // isError={}
                        // errorMessage="This is an error"
                      />
                    </div>
                    <div className="col-sm-3">
                      <NumberInput
                        id="hip"
                        name="hip"
                        formLabel={`HIP(in)`}
                        size={`sm`}
                        onChange={handleAddChange}
                        // isError={}
                        // errorMessage="This is an error"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-3">
                      <NumberInput
                        id="whr"
                        name="whr"
                        formLabel={`WHR`}
                        size={`sm`}
                        onChange={handleAddChange}
                        value={addVital.whr}
                        // value={
                        //   addVital.waist
                        //     ? parseFloat(addVital.waist / addVital.hip).toFixed(2)
                        //     : "0.00"
                        // }
                        // isError={}
                        // errorMessage="This is an error"
                      />
                    </div>
                    <div className="col-sm-3">
                      <NumberInput
                        id="temperature"
                        name="temperature"
                        formLabel={`TEMPERATURE (°C)`}
                        size={`sm`}
                        onChange={handleAddChange}
                        required={true}
                      />
                    </div>
                    <div className="col-sm-3">
                      <NumberInput
                        id="bp"
                        name="bp"
                        formLabel={`BLOOD PRESSURE (mmHg)`}
                        size={`sm`}
                        value={addVital.bp}
                        onChange={handleAddChange}
                        required={true}
                      />
                    </div>
                    <div className="col-sm-3">
                      <NumberInput
                        id="heart_rate"
                        name="heart_rate"
                        formLabel={`HEART RATE (bpm)`}
                        size={`sm`}
                        onChange={handleAddChange}
                        required={true}
                        // isError={}
                        // errorMessage="This is an error"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-3">
                      <NumberInput
                        id="respiratory_rate"
                        name="respiratory_rate"
                        formLabel={`RESPIRATORY RATE`}
                        size={`sm`}
                        onChange={handleAddChange}
                        required={true}
                        // isError={}
                        // errorMessage="This is an error"
                      />
                    </div>
                    <div className="col-sm-3">
                      <NumberInput
                        id="oxygen_saturation"
                        name="oxygen_saturation"
                        formLabel={`OXYGEN SATURATION`}
                        size={`sm`}
                        onChange={handleAddChange}
                      />
                    </div>
                    <div className="col-sm-3">
                            <NumberInput
                              id="left_eye_w_correction"
                              name="left_eye_w_correction"
                              formLabel={`LEFT EYE VISION (w/ correction)`}
                              size={`sm`}
                              onChange={handleAddChange}
                            />
                          </div>
                           <div className="col-sm-3">
                            <NumberInput
                              id="right_eye_w_correction"
                              name="right_eye_w_correction"
                              formLabel={`RIGHT EYE VISION (w/ correction)`}
                              size={`sm`}
                              onChange={handleAddChange}
                            />
                    </div>
                     <div className="col-sm-3">
                            <NumberInput
                              id="left_eye_wo_correction"
                              name="left_eye_wo_correction"
                              formLabel={`LEFT EYE VISION (w/o correction)`}
                              size={`sm`}
                              onChange={handleAddChange}
                            />
                          </div>
                   <div className="col-sm-3">
                            <NumberInput
                              id="right_eye_wo_correction"
                              name="right_eye_wo_correction"
                              formLabel={`RIGHT EYE VISION (w/o correction)`}
                              size={`sm`}
                              onChange={handleAddChange}
                            />
                          </div>
                  </div>
                </>
              )}
              {state?.state?.months <= 24 && (
                <>
                  {" "}
                  <label
                    style={{
                      fontWeight: "bold",
                      textDecoration: "underline",
                    }}
                  >
                    Pedriatic Client aged 0-24
                  </label>
                  <div className="row mt-3">
                    <div className="col">
                      <NumberInput
                        id="weight"
                        name="weight"
                        formLabel={`WEIGHT (kg)`}
                        size={`sm`}
                        onChange={handleAddChange}
                      />
                    </div>
                    <div className="col">
                      <NumberInput
                        id="weight_in_lb"
                        name="weight_in_lb"
                        formLabel={`WEIGHT (lb)`}
                        value={addVital.weight_in_lb}
                        size={`sm`}
                        onChange={handleAddChange}
                        // isError={}
                        errorMessage="This is an error"
                        disabled={true}
                      />
                    </div>
                    <div className="col">
                      <NumberInput
                        id="length"
                        name="length"
                        formLabel={`LENGTH (cm)`}
                        size={`sm`}
                        onChange={handleAddChange}
                        // isError={}
                        errorMessage="This is an error"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <NumberInput
                        id="head_circumference"
                        name="head_circumference"
                        formLabel={`HEAD CIRCUMFERENCE (cm)`}
                        size={`sm`}
                        onChange={handleAddChange}
                        // isError={}
                        errorMessage="This is an error"
                      />
                    </div>
                    <div className="col">
                      <NumberInput
                        id="skinfold_thickness"
                        name="skinfold_thickness"
                        formLabel={`SKINFOLD THICKNESS (cm)`}
                        size={`sm`}
                        onChange={handleAddChange}
                        // isError={}
                        errorMessage="This is an error"
                      />
                    </div>
                    <div className="col">
                      <NumberInput
                        id="body_circumference_waist"
                        name="body_circumference_waist"
                        formLabel={`BODY CIRCUMFERENCE WAIST (cm)`}
                        size={`sm`}
                        onChange={handleAddChange}
                        // isError={}
                        errorMessage="This is an error"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <NumberInput
                        id="hip_in_cm"
                        name="hip_in_cm"
                        formLabel={`HIP (cm)`}
                        size={`sm`}
                        onChange={handleAddChange}
                        // isError={}
                        errorMessage="This is an error"
                      />
                    </div>
                    <div className="col">
                      <NumberInput
                        id="limbs"
                        name="limbs"
                        formLabel={`LIMBS (cm)`}
                        size={`sm`}
                        onChange={handleAddChange}
                        // isError={}
                        errorMessage="This is an error"
                      />
                    </div>
                    <div className="col">
                      <NumberInput
                        id="muac"
                        name="muac"
                        formLabel={`MIDDLE UPPER ARM CIRCUMFERENCE (cm)`}
                        size={`sm`}
                        onChange={handleAddChange}
                        // isError={}
                        errorMessage="This is an error"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-4">
                      <NumberInput
                        id="temperature"
                        name="temperature"
                        formLabel={`TEMPERATURE (°C)`}
                        size={`sm`}
                        onChange={handleAddChange}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="row mt-3">
                <div className="col">
                  <label className="form-label">Blood Type (as available)</label>
                  <Radio.Group
                    className="w-full mt-2"
                    value={addVital?.blood_type}
                    onChange={(e) =>
                      handleAddChange({
                        target: { name: "blood_type", value: e.target.value },
                      })
                    }
                  >
                    <Radio value="A+">A+</Radio>
                    <Radio value="B+">B+</Radio>
                    <Radio value="AB+">AB+</Radio>
                    <Radio value="O+">O+</Radio>
                    <Radio value="A-">A-</Radio>
                    <Radio value="B-">B-</Radio>
                    <Radio value="AB-">AB-</Radio>
                    <Radio value="O-">O-</Radio>
                  </Radio.Group>
                </div>
              </div>
              <hr />
              <div className="row mt-3">
                <div className="col">
                  {/* <TextArea
                    required={true}
                    id="complaint"
                    name="complaint"
                    formLabel={`1. Chief Complaint (Please describe.)`}
                    value={addVital?.chief_complaint}
                    onChange={handleAddChange}
                  /> */}
                  <CreateSelectField
                    id={"complaint"}
                    errorMessage="Required"
                    className="dropsearch-filter"
                    name="complaint"
                    size={`sm`}
                    formLabel={"Chief Complaint"}
                    options={suggestComplaint}
                    value={{
                      label: addVital?.complaint,
                      value: addVital?.complaint,
                    }}
                    isMessage={true}
                    onChange={(e) =>
                      handleAddComplaintChange(e, "chief_complaint")
                    }
                    onInputChange={(inputValue) => inputValue.toUpperCase()}
                  />
                </div>
              </div>
              {/*Complaint 2*/}
              <div className="row mt-3">
                <div className="col">
                  <p className="form-label align-left">
                    2. Do you experience any of the following: loss of appetite,
                    lack of sleep, unexplained weight loss, feeling
                    down/depressed, fever, headache, memory loss, blurring of
                    vision, or hearing loss?
                  </p>
                  <Radio.Group
                    className="w-full mt-2"
                    name="has_complaint_2"
                    value={addVital?.has_complaint_2}
                    onChange={handleAddChange}
                  >
                    <Radio value="1">Yes</Radio>
                    <Radio value="0">No</Radio>
                  </Radio.Group>
                </div>
              </div>
              {addVital?.has_complaint_2 === "1" && (
                <>
                  <div className="row mt-3">
                    <div className="col">
                      <TextArea
                        required={true}
                        id="complaint_2"
                        name="complaint_2"
                        formLabel={`If yes, please explain:`}
                        value={addVital?.complaint_2}
                        onChange={handleAddChange}
                      />
                    </div>
                  </div>
                </>
              )}
              {/*Complaint 3*/}
              <div className="row mt-3">
                <div className="col">
                  <p className="form-label align-left">
                    3. Do you experience any of the following: cough/colds,
                    chest pain, palpitations, or difficulty in breathing?
                  </p>
                  <Radio.Group
                    className="w-full mt-2"
                    name="has_complaint_3"
                    value={addVital?.has_complaint_3}
                    onChange={handleAddChange}
                  >
                    <Radio value="1">Yes</Radio>
                    <Radio value="0">No</Radio>
                  </Radio.Group>
                </div>
              </div>
              {addVital?.has_complaint_3 === "1" && (
                <>
                  <div className="row mt-3">
                    <div className="col">
                      <TextArea
                        required={true}
                        id="complaint_3"
                        name="complaint_3"
                        formLabel={`If yes, please explain:`}
                        value={addVital?.complaint_3}
                        onChange={handleAddChange}
                      />
                    </div>
                  </div>
                </>
              )}
              {/*Complaint 4*/}
              <div className="row mt-3">
                <div className="col">
                  <p className="form-label align-left">
                    4. Do you experience any of the following: abdominal pain,
                    vomiting, change in bowel movement, rectal bleeding, or
                    bloody/tarry stools?
                  </p>
                  <Radio.Group
                    className="w-full mt-2"
                    name="has_complaint_4"
                    value={addVital?.has_complaint_4}
                    onChange={handleAddChange}
                  >
                    <Radio value="1">Yes</Radio>
                    <Radio value="0">No</Radio>
                  </Radio.Group>
                </div>
              </div>
              {addVital?.has_complaint_4 === "1" && (
                <>
                  <div className="row mt-3">
                    <div className="col">
                      <TextArea
                        required={true}
                        id="complaint_4"
                        name="complaint_4"
                        formLabel={`If yes, please explain:`}
                        value={addVital?.complaint_4}
                        onChange={handleAddChange}
                      />
                    </div>
                  </div>
                </>
              )}
              {/*Complaint 5*/}
              <div className="row mt-3">
                <div className="col">
                  <p className="form-label align-left">
                    5. Do you experience any of the following: frequent
                    urination, frequent eating, frequent intake of fluids?
                  </p>
                  <Radio.Group
                    className="w-full mt-2"
                    name="has_complaint_5"
                    value={addVital?.has_complaint_5}
                    onChange={handleAddChange}
                  >
                    <Radio value="1">Yes</Radio>
                    <Radio value="0">No</Radio>
                  </Radio.Group>
                </div>
              </div>
              {addVital?.has_complaint_5 === "1" && (
                <>
                  <div className="row mt-3">
                    <div className="col">
                      <TextArea
                        required={true}
                        id="complaint_5"
                        name="complaint_5"
                        formLabel={`If yes, please explain:`}
                        value={addVital?.complaint_5}
                        onChange={handleAddChange}
                      />
                    </div>
                  </div>
                </>
              )}
              {/*Complaint 6*/}
              <div className="row mt-3">
                <div className="col">
                  <p className="form-label align-left">
                    6. For male and female, do you experience any of the
                    following: pain or discomfort on urination, frequency of
                    urination, dribbling of urine, pain during/after sex, blood
                    in urine, or foul-smelling genital discharge?
                  </p>
                  <Radio.Group
                    className="w-full mt-2"
                    name="has_complaint_6"
                    value={addVital?.has_complaint_6}
                    onChange={handleAddChange}
                  >
                    <Radio value="1">Yes</Radio>
                    <Radio value="0">No</Radio>
                  </Radio.Group>
                </div>
              </div>
              {addVital?.has_complaint_6 === "1" && (
                <>
                  <div className="row mt-3">
                    <div className="col">
                      <TextArea
                        required={true}
                        id="complaint_6"
                        name="complaint_6"
                        formLabel={`If yes, please explain:`}
                        value={addVital?.complaint_6}
                        onChange={handleAddChange}
                      />
                    </div>
                  </div>
                </>
              )}
              {state?.state?.patient_sex?.toUpperCase() === "FEMALE" && (
                <>
                  <div className="row mt-3">
                    <div className="col-12">
                      <p>7. For females only,</p>
                    </div>
                    <div className="col">
                      {/* <DateField
                        id="last_mens_period"
                        name="last_mens_period"
                        formLabel={`a. Last menstrual period`}
                        size={`sm`}
                        onChange={handleAddChange}
                        // isError={}
                        errorMessage="This is an error"
                      /> */}
                      <TextField
                        id="last_mens_period"
                        name="last_mens_period"
                        formLabel={`a. Last menstrual period`}
                        size={`sm`}
                        onChange={handleAddChange}
                        // isError={}
                        errorMessage="This is an error"
                      />
                    </div>
                    <div className="col">
                      {/* <DateField
                        id="first_mens_period"
                        name="first_mens_period"
                        formLabel={`b. First menstrual period`}
                        size={`sm`}
                        onChange={handleAddChange}
                        // isError={}
                        errorMessage="This is an error"
                      /> */}
                      <TextField
                        id="first_mens_period"
                        name="first_mens_period"
                        formLabel={`b. First menstrual period`}
                        size={`sm`}
                        onChange={handleAddChange}
                        // isError={}
                        errorMessage="This is an error"
                      />
                    </div>
                    <div className="col">
                      <NumberInput
                        id="preg_count"
                        name="preg_count"
                        formLabel={`Number of pregnancy`}
                        size={`sm`}
                        onChange={handleAddChange}
                      />
                    </div>
                  </div>
                  {/*Complaint 8*/}
                  <div className="row mt-3">
                    <div className="col">
                      <p className="form-label align-left">
                        8. Do you experience any of the following: muscle spasm,
                        tremors, weakness; muscle/joint pain stiffness,
                        limitation of movement?
                      </p>
                      <Radio.Group
                        className="w-full mt-2"
                        name="has_complaint_8"
                        value={addVital?.has_complaint_8}
                        onChange={handleAddChange}
                      >
                        <Radio value="1">Yes</Radio>
                        <Radio value="0">No</Radio>
                      </Radio.Group>
                    </div>
                  </div>
                </>
              )}
              {state?.state?.patient_sex?.toUpperCase() === "MALE" && (
                <>
                  {/*Complaint 8*/}
                  <div className="row mt-3">
                    <div className="col">
                      <p className="form-label align-left">
                        7. Do you experience any of the following: muscle spasm,
                        tremors, weakness; muscle/joint pain stiffness,
                        limitation of movement?
                      </p>
                      <Radio.Group
                        className="w-full mt-2"
                        name="has_complaint_8"
                        value={addVital?.has_complaint_8}
                        onChange={handleAddChange}
                      >
                        <Radio value="1">Yes</Radio>
                        <Radio value="0">No</Radio>
                      </Radio.Group>
                    </div>
                  </div>
                </>
              )}
              {addVital?.has_complaint_8 === "1" && (
                <>
                  <div className="row mt-3">
                    <div className="col">
                      <TextArea
                        required={true}
                        id="complaint_8"
                        name="complaint_8"
                        formLabel={`If yes, please explain:`}
                        value={addVital?.complaint_8}
                        onChange={handleAddChange}
                      />
                    </div>
                  </div>
                </>
              )}
              <hr className="mt-3" />
              <label
                style={{
                  fontWeight: "bold",
                  textDecoration: "underline",
                }}
              >
                General Survey
              </label>
              <div className="row">
                <div className="col">
                  {/* <p className="form-label align-left">General Survey</p> */}
                  <Radio.Group
                    className="w-full mt-2"
                    name="general_survey"
                    value={addVital?.general_survey}
                    onChange={handleAddChange}
                  >
                    <Radio value="Awake and alert">Awake and alert</Radio>
                    <Radio value="Altered Sensorium">Altered Sensorium</Radio>
                  </Radio.Group>
                </div>
              </div>
            </div>
          </div>
          {/* {state?.state?.is_fpe === 0 && (
            <>
              <div className="row justify-content-end mt-5 mb-3">
                <div className="col-2">
                  <BtnAdd
                    label={"Submit"}
                    size={"sm"}
                    onClick={handleSubmit}
                    disabled={
                      Object.values(addVital).every((value) => value === "") ||
                      Object.values(addVital.complaint).every(
                        (value) => value === "" 
                      ) ||
                      !selectedDoctor
                    }
                    isClicked={isLoading}
                  />
                </div>
                <div className="col-2">
                  <BtnSave
                    label={"Schedule an Appointment"}
                    size={"sm"}
                    isClicked={isLoading}
                    onClick={handleSchedule}
                  />
                </div>
              </div>
            </>
          )} */}
          <div className="row justify-content-end mt-5 mb-3">
            <div className="col-2">
              <BtnAdd
                label={"Next"}
                size={"sm"}
                onClick={handleSubmit}
                disabled={
                  !addVital?.general_survey ||
                  !addVital?.height ||
                  !addVital?.bmi ||
                  !addVital?.temperature ||
                  !addVital?.bp ||
                  !addVital?.heart_rate ||
                  !addVital?.respiratory_rate
                }
                isClicked={isLoading}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewPatientVitalSigns
